import React, { useContext, useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import DocumentsToAcceptForm from './DocumentsToAcceptForm';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { UPDATE_DOCUMENTS_STATUS_MUTATION } from '../../../../pages/Accounts/DocumentManagement/services/document-management.service';
import { DOCUMENTS_TO_ACCEPT_QUERY } from '../../services/dashboard.service';

const DocumentsToAccept = () => {
  const [pendingChangeRequests, setPendingChangeRequests] = useState([]);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [updateDocumentChangeAcceptanceRequestsStatuses] = useMutation(UPDATE_DOCUMENTS_STATUS_MUTATION);
  const { error, data } = useQuery(DOCUMENTS_TO_ACCEPT_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!!data && !!data.account) {
      setPendingChangeRequests(data.account.pendingDocumentChangeAcceptanceRequests);
    }
    // eslint-disable-next-line
  }, [data]);

  if (error) {
    growlErrors(growl, error);
  }

  const updateStatuses = async (inputTypes, callback) => {
    try {
      await updateDocumentChangeAcceptanceRequestsStatuses({
        variables: {
          input: {
            accountId: currentAccount,
            inputTypes,
          },
        },
      });

      callback();
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const getStatus = (
    ownerTermsOfUseStatus,
    dataProcessingAgreementStatus,
    userTermsOfUseStatus,
    pendingChangeRequest,
  ) => {
    if (pendingChangeRequest.documentType === 'OWNER_TERMS_OF_USE') {
      return ownerTermsOfUseStatus;
    }

    if (pendingChangeRequest.documentType === 'DATA_PROCESSING_AGREEMENT') {
      return dataProcessingAgreementStatus;
    }

    if (pendingChangeRequest.documentType === 'USER_TERMS_OF_USE') {
      return userTermsOfUseStatus;
    }

    return 'ACCEPTED';
  };

  const handleSubmit = ({ ownerTermsOfUseStatus, dataProcessingAgreementStatus, userTermsOfUseStatus }) => {
    const inputTypes = pendingChangeRequests.map((pendingChangeRequest) => {
      return {
        id: pendingChangeRequest.id,
        documentId: pendingChangeRequest.documentId,
        documentType: pendingChangeRequest.documentType,
        status: getStatus(
          ownerTermsOfUseStatus,
          dataProcessingAgreementStatus,
          userTermsOfUseStatus,
          pendingChangeRequest,
        ),
      };
    });

    const callback = () => setPendingChangeRequests([]);

    updateStatuses(inputTypes, callback);
  };

  return (
    <Dialog
      header="Documents"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={pendingChangeRequests.length > 0}
      onHide={() => {}}
      position="center"
    >
      <DocumentsToAcceptForm handleSubmit={handleSubmit} pendingChangeRequests={pendingChangeRequests} />
    </Dialog>
  );
};

export default DocumentsToAccept;
